(function($){

  /**Home page card carousel */
  jQuery(document).ready(function ($) {
    
    jQuery(".js-image-card-carousel").owlCarousel({
    loop: true,
    nav: true,

    mouseDrag: true,
    touchDrag: true,
    dots: false,
    autoWidth:true,
    autoplay: false,
    autoHeight: true,
    autoplayTimeout: 5000,
  })
    
    setTimeout(function(){  
     
    /*Cart Page Hide Gpay button*/
    jQuery("#dynamic-checkout-cart li").each(function (index) {
     
            var buttonType = jQuery(this).children("div").attr("data-testid");
            if (buttonType == "GooglePay-button") {
              
                jQuery(this).hide();
            }
        })
    }, 3000);
    
    
    
     setTimeout(function(){  
     jQuery(".js-review-rating-star").html(jQuery(".yotpo-bottomline").children(".yotpo-stars").html());
         jQuery(".js-review-count").html(jQuery(".yotpo-bottomline").children(".text-m").html());
    /*Cart Page Hide Gpay button*/
   
    }, 3000);
 })
  /**All anchor check url if its other website then open in new tab*/
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
  
  /*announcement close*/
   jQuery('.js-announcement-close').on('click', function(e){
     createCookie("announcement","hide",10000);
     jQuery(".header__announcement").remove();
     jQuery(".intro").addClass("announcement-hide");
    
   })
   
   if(readCookie("announcement")!=null) 
 {
    if(readCookie("announcement")!="")
   {
      jQuery(".header__announcement").remove();
     jQuery(".intro").addClass("announcement-hide");
   }
 }

})(jQuery); 


jQuery(window).scroll(function () {
    var sticky = jQuery(".header__announcement"),
      scroll = jQuery(window).scrollTop();
    if (scroll >= 100) {
      sticky.addClass("fixed");
    } else {
      sticky.removeClass("fixed");
    }
  });

/**
* Function to create cookie
**/
function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = escape(name) + "=" + escape(value) + "; path=/";
}


/**
* Function to get cookie
**/
function readCookie(name) {
    var nameEQ = escape(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
    }
    return null;
}


/**
* Function to delete cookie
**/
function eraseCookie(name) {
    createCookie(name, "", -1);
}